import { render } from "./TopPanel.vue?vue&type=template&id=780245c0"
import script from "./TopPanel.vue?vue&type=script&lang=js"
export * from "./TopPanel.vue?vue&type=script&lang=js"

import "./TopPanel.vue?vue&type=style&index=0&id=780245c0&lang=sass"

import exportComponent from "C:\\Riman\\Web\\Alex\\ars\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__